import { render } from "./TheH01PointAchievementPanel.vue?vue&type=template&id=2c0d4d36&scoped=true&ts=true"
import script from "./TheH01PointAchievementPanel.vue?vue&type=script&lang=ts"
export * from "./TheH01PointAchievementPanel.vue?vue&type=script&lang=ts"

import "./TheH01PointAchievementPanel.vue?vue&type=style&index=0&id=2c0d4d36&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0d4d36"]])

export default __exports__